module.exports = __webpack_public_path__ + "img/smartcare-logo.4756d5ce.png";